import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { TextField } from "@mui/material";
import p4lLogo from "../assets/logo/PfL Logo no words 2023-11-21-01.png";
import signInClient from "../auth";
import Button from "../componentLibrary/Button";

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const handleSendVerificationCode = async () => {
    setIsLoading(true);
    setError("");

    if (email.trim() === "") {
      setError("Please provide a valid username.");
      setIsLoading(false);
      return;
    }

    try {
      const validationResponse = await signInClient.post(
        "/forgot-password/validate-username",
        { username: email },
      );

      if (!validationResponse.data.exists) {
        setError("username-not-found");
        setIsLoading(false);
        return;
      }

      await signInClient.post("/forgot-password", { email });
      navigate("/verification-code");
    } catch (error) {
      setError("Error sending verification code. Please try again.");
      setIsLoading(false);
    }
  };

  return (
    <div className="flex flex-col mx-auto w-80 mt-24 mb-12 space-y-4">
      <div className="flex flex-col items-center">
        <img
          src={p4lLogo}
          alt="Psych For Life logo"
          className="w-32 h-32 mb-2"
        />
        <p className="text-gray-700 text-3xl">Psych For Life&reg;</p>
      </div>
      <p className="text-gray-700 text-2xl">Forgot Password</p>
      <TextField
        label="Username"
        variant="outlined"
        fullWidth
        type="username"
        name="username"
        value={email}
        onChange={(e) => {
          setError("");
          setEmail(e.target.value);
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            handleSendVerificationCode();
          }
        }}
      />
      <Button
        className="w-full"
        onClick={handleSendVerificationCode}
        loading={isLoading}
      >
        Send Verification Code
      </Button>
      {error === "username-not-found" ? (
        <p className="text-red-500">
          This username does not connect to an account with Psych for Life®. If
          you forgot your username, contact{" "}
          <a
            href="mailto:support@psychforlife.org"
            className="text-blue-500 hover:text-blue-600 underline"
          >
            support@psychforlife.org
          </a>
          .
        </p>
      ) : error ? (
        <p className="text-red-500">{error}</p>
      ) : null}
    </div>
  );
};

export default ForgotPasswordPage;
